import { createStore } from 'vuex'

import util from './store-utils'
import searchUtil from './store-search-utils'

import userStore, { USER_STORE_COMMIT } from './user-store'
import productStore, { PRODUCT_STORE_COMMIT } from './product-store'
import settings from '../settings'

const SET_BASE_MODEL_LOADING = "setBaseModelLoading"
const SET_SEARCH_INDEX_MODEL_LOADING = "setSearchIndexModelLoading"

export const STORE_SORT = {
	SORT_SEARCH: { property: "score", name: "Bästa träff", short: "Bästa", desc: true },
	SORT_SEARCH_WORST: { property: "score", name: "Sämsta träff", short: "Sämsta", desc: false },
	SORT_DEFAULT: { property: "productId", name: "Nyaste först", short: "Nyaste", desc: true }
} 

// this.$store.commit(STORE_COMMIT.SET_PAGE_MENU_OPEN, false);
export const STORE_COMMIT = {
	DISPLAYED_EVENT: "displayedEvent",
	SET_LOGIN_TOKEN: "setLoginToken",
	APPEND_EVENT_LOG: "appendEventLog",
	TOGGLE_DEBUG: "toggleDebug",
	SET_ALL_EVENTS_READ: "setAllEventsRead",
	UPDATE_TABLE_CONFIG: "updateTableConfig",
	USER_IS_ACTIVE: "userIsActive",
	SET_PAGE_MENU_OPEN: "setPageMenuOpen",
	SET_SIDE_MENU_KEY: "setSideMenuKey",
	//REBUILD_SEARCH_MODEL: "rebuildSearchModel",
	SEARCH_PRODUCT: "searchProduct",
	SET_SEARCH_PRODUCT_CONFIG: "setSearchProductConfig",
	CREATE_TEST_DATA: "createTestData",
	SELECT_PRODUCT_TYPE: "selectProductType",
	SELECT_PRODUCT_TYPE_BY_URL_KEY: "selectProductTypeByUrlKey", 
	SELECT_PRODUCT_TYPE_BY_PT: "selectProductTypeByPT", 
	CREATE_MODEL: "createModel",
	SET_SORT_SEARCH: "setSortSearch",
	SET_SORT: "setSort",
	SET_SEARCH_MODEL: "setSearchModel",
	UPDATE_SEARCH_INDEX_MODEL: "updateSearchIndexModel",
	SET_SHOW_START_SPINNER: "setShowStartSpinner",
	SET_REBUILD_SEARCH_MODEL: "setRebuildingSearchModel",
	SELECT_PRODUCT_GROUP_KEY: "selectProductGroupKey"


}

export const STORE_ACTION = {
	API_TEST_ACTION: "apiTestAction",
	RETRY_ACTION: "retryAction",
	TEST_REMOTE_ERROR: "testRemoteError",
	GET_BASE_MODEL: "getBaseModel",
	GET_START_MODEL: "getStartModel",
	GET_SEARCH_INDEX_MODEL: "getSearchIndexModel",
	REMOTE_EVENT: "createRemoteEvent",
	GET_STATUS: "getStatus",
	LOGIN: "login",
	LOGOUT: "logout",
	APPEND: "append",
	SEARCH_PRODUCT_A: "searchProductA",
	REBUILD_SEARCH_MODEL_ACTION: "rebuildSearchModelAction"

}

export const STORE_GETTER = {
	REQUEST_COUNT: "requestCount",
	//UNREAD_ERROR_MESSAGE_COUNT: "unReadErrorMessageCount",
	UNREAD_ERROR_MESSAGE: "unReadErrorMessage",
	BASE_MODEL: "baseModel",
	START_MODEL: "startModel",
	SEARCH_MODEL: "searchModel",
	TABLE_CONFIGS: "tableConfigs",
	IS_USER_ACTIVE: "isUserActive",
	LOGIN_TOKEN: "loginToken",
	IS_LOGGED_IN: "isLoggedIn",
	IS_PAGE_MENU_OPEN: "isPageMenuOpen",
	SIDE_MENU_KEY: "sideMenuKey",
	SEARCH_INDEX_MODEL: "searchIndexModel",
	SEARCH_PRODUCT_RESULT: "searchProductResult",
	SEARCH_PRODUCT_CONFIG: "searchProductConfig",
	PRODUCT_TYPE_SELECTED: "productTypeSelected",
	PRODUCT_TYPE_SELECTED_MC: "productTypeSelectedMc",
	PRODUCT_TYPE_LIST: "productTypeList",
	PRODUCT_TYPE_MODEL: "productTypeModel",
	CATEGORY_MODEL: "categoryModel",
	MANUFACTOR_LIST: "manufactorList",
	MANUFACTOR_LIST_ALL: "manufactorListAll",
	BASE_MODEL_LOADING: "baseModelLoading",
	CATEGORY_PRODUCT_COUNT_LIST: "categoryProductCountList",
	PRODUCT_LIST_FOR_SELECTED_PRODUCT_GROUP: "productListForSelectedProductGroup",
	SEARCH_INDEX_MODEL_LOADING: "searchIndexModelLoading",
	SHOW_START_SPINNER: "showStartSpinner",
	PRODUCT_SEARCH_ENABLED: "productSearchEnabled",
	REBUILDING_SEARCH_MODEL: "rebuildingSearchModel",
	BASE_MODEL_COMPLETE_DATE: "baseModelCompleteDate"
}


export default createStore({
	state: {
		baseUrl: null,
		debug: false,
		requestCount: 0,
		loginToken: null,
		baseModel: null,
		baseModelLoading: false,
		eventList: [],
		tableConfigs: [],
		userActive: new Date(),
		apiVersion: 0,
		loginStatusInterval: 1000,
		pageMenuOpen: false,
		sideMenuKey: null, // FP: att skicka in för att sätta en viss menu
		searchModel: {
			productList: [],
			meta: { name: "Model" }
		},
		productTypeModel: { selected: null, list: [{ key: "mc", name: "MC", pt: 1, urlKey: "mc", label: "Motorcykel", outletKey: "OUTLET_MC" }, { key: "bike", name: "Cykel", pt: 2, urlKey: "cykel", label: "Cykel", outletKey: "OUTLET_CYKEL" }, { key: "car", name: "Bil / Olja", pt: 3, urlKey: "bil", label: "Bil / Olja", outletKey: null }] }, 
		//categoryType: null,
		//categoryTypeList: [{ key: "mc", name: "MC" }, { key: "bike", name: "Cykel" }, { key: "oil", name: "Olja" }], { property: "score", name: "Bästa träff", short: "Bästa", desc: true }
		searchProductResult: { productList: [], meta: { name: "Result" } },
		searchProductConfig: { name: "config", searchPhrase: "", manufactor: null, category: null, brand: null, mc: null, year: null, popoverOpen: false, sort: STORE_SORT.SORT_DEFAULT, layout: "GRID", model2: { totalCount: 0, resultCount: 0, productList: [], productListSearch: [] }, productGroupKey: null, filter: {onlyInStock: false} },
		searchIndexModel: null,
		searchIndexModelLoading: false,
		showStartSpinner: true,
		rebuildingSearchModel: false,
		baseModelCompleteDate: null,


	},
	getters: {

		productListForSelectedProductGroup(state){
			const currentKey = state.searchProductConfig?.productGroupKey

			if (!currentKey){
				return null;
			}

			const productGroup = state.productStore.data.productGroupList?.find(productGroup => productGroup.key == currentKey)

			if (!productGroup || !productGroup.productIdList || productGroup.productIdList?.length == 0){
				return null;
			}

			var productList = [];
			productGroup?.productIdList?.forEach(productId => {
				const product = state.productStore.data.productList[productId];
				
				if(product){
					productList.push(product);
				}
				

			})

			return productList;

		},

		requestCount(state) {
			var count = state.requestCount;
			count += state.productStore.data.requestCount
			count += state.userStore.data.requestCount
			return count;
		},
		/*unReadErrorMessageCount(state) {
			return state.eventList.filter(event => event.status == "ERROR" && event.read == false).length
		},*/
		unReadErrorMessage(state) {
			return state.eventList.filter(event => event.status == "ERROR" && event.read == false)
		},
		baseModel(state) {
			return state.baseModel
		},
		baseModelLoading(state){
			return state.baseModelLoading
		},
		startModel(state) {
			return state.startModel
		},
		tableConfigs(state) {
			return state.tableConfigs;
		},
		loginToken(state) {
			return state.loginToken
		},
		isLoggedIn(state) {
			return state.loginToken != null
		},
		isUserActive(state) {

			return ((new Date().getTime() - state.userActive.getTime()) / 1000) > 10 // aktiv inom tio sekunder
		},
		isPageMenuOpen(state) {
			return state.pageMenuOpen
		},
		searchModel(state) {
			return state.searchModel
		},
		searchProductResult(state) {
			return state.searchProductResult
		},
		searchProductConfig(state) {
			return state.searchProductConfig
		},
		productTypeSelected(state){
			return state.productTypeModel?.selected
		},
		productTypeSelectedMc(state) {
			return state.productTypeModel?.selected?.key == "mc"
		},
		productTypeList(state){
			return state.productTypeModel?.list
		},
		productTypeModel(state) {
			return state.productTypeModel
		},

		categoryProductCountList(state){
			var productCountList = [];
			state.baseModel?.categoryModel?.productCount?.forEach(item => {
				productCountList[item.categoryId] = item.productCount
			})

			return productCountList;

		},
		categoryModel(state){
			return searchUtil.getCategoryModel(state.baseModel, state.productTypeModel);
		},

		manufactorList(state){
			return searchUtil.getManufactorList(state.baseModel, state.productTypeModel);
		},
		manufactorListAll(state){
			return state.baseModel?.manufactorList?.filter(manufactor => manufactor != null)
		},
		sideMenuKey(state){
			return state.sideMenuKey;
		},
		searchIndexModel(state){
			return state.searchIndexModel;
		},
		searchIndexModelLoading(state) {
			return state.searchIndexModelLoading;
		},
		showStartSpinner(state){
			return state.showStartSpinner
		},
		productSearchEnabled(state){
			
			const currentKey = state.searchProductConfig?.productGroupKey

			const productGroup = state.productStore.data.productGroupList?.find(productGroup => productGroup.key == currentKey)

			if (productGroup && productGroup.searchable){
				return true
			}

			return false

			
		},
		rebuildingSearchModel(state){
			return state.rebuildingSearchModel
		},
		baseModelCompleteDate(state){

			return state.baseModelCompleteDate

		}




	},
	actions: {



		/*apiTestAction({ commit }, { data }) {

			console.log("FP: ", commit);
			console.log("FP: ", data);

			return axios.get('test/'
			).then(result => {

				util.handleResult(result, commit); // så vi får med det som ska till loggen... 
				//	alert("OK");
				if (result && result.data && result.data.status == "OK") {


					return result
				}


			}).catch(error => {
				util.handleError(error, commit);
			})

		},*/
		apiTestAction({ commit, rootState }, { data }) {
			console.log('FP: commit', commit);
			console.log('FP: data', data);
			

			const request = util.getGETRequest(this.state.loginToken, data.background);

			commit("requestStart");

			return fetch(settings.baseUrl + "test/", request).then(response => {

				console.log('FP: response: ', response);

				return util.getJson(commit, response, data, rootState.debug).then(json => {

					console.log('FP: json:', json);
					return json

				})


			}).catch(error => {
				console.error("FP: error: ", error);
				util.appendEventLogError(commit, "Error has occured. " + error, true)

				return { status: "FAIL", message: error }
			}).finally(() => {
				commit("requestComplete");

			})
		},
		retryAction({ commit, rootState }, { data }) {
			console.log('FP: commit', commit);
			console.log('FP: data', data);

			if (!data.retry) {
				data.retry = 10;
			}


			const request = util.getPOSTRequest(this.state.loginToken, data.background, { retry: data.retry});

			commit("requestStart");

			return fetch(settings.baseUrl + "retry", request).then(response => {

				console.log('FP: response: ', response);

				return util.getJson(commit, response, data, rootState.debug).then(json => {

					console.log('FP: json:', json);
					//return json

					data.retry = data.retry - 1

					if (data.retry > 5){
						//return dispatch('retryAction', data);
						return json;
					}else{
						return json;
					}
					

				})


			}).catch(error => {
				console.error("FP: error: ", error);
				//util.appendEventLogError(commit, "Error has occured. " + error, true)


				return { status: "FAIL", message: "ERROR: " + error }
			}).finally(() => {
				commit("requestComplete");

			})
		},
		createRemoteEvent({ commit, rootState }, { data }) {
			console.log("FP: ", commit);
			console.log("FP: ", data);

			let type = data.type

			if (!type) {
				type = "info";
			}

			type = type.toLowerCase()

			const request = util.getPOSTRequest(this.state.loginToken, data.background, { message: "A " + type + "-message from webbclient (fetch)" });

			commit("requestStart");

			return fetch(settings.baseUrl + "event/" + type, request).then(response => {

				console.log('FP: response: ', response);

				return util.getJson(commit, response, data, rootState.debug).then(json => {

					if (json.status == "OK") {
						alert("OK");
					} else {
						alert("FAILED, " + json.message);
					}

					console.log('FP: json:', json);
					return json

				})

			}).catch(error => {
				console.error("FP: error: ", error);
				util.appendEventLogError(commit, "Error has occured. " + error, true)
				return { status: "FAIL", message: error }
			}).finally(() => {
				commit("requestComplete");

			})


		},

		/*createRemoteEvent({ commit }, { data }) {
			console.log("FP: ", commit);
			console.log("FP: ", data);

			let type = data.type

			if (!type) {
				type = "info";
			}
			type = type.toLowerCase()
			return axios.post('event/' + type, { message: "A " + type + "-message from webbclient" }
			).then(result => {
				alert("OK");
				if (result && result.data && result.data.status == "OK") {
					return result
				}
			}).catch(error => {
				util.handleError(error, commit);
			})


		},*/

		testRemoteError({ commit, rootState }, { data }) {
			console.log("FP: ", commit);
			console.log("FP: ", data);


			commit("requestStart");

			const request = util.getGETRequest(this.state.loginToken, data.background);

			return fetch(settings.baseUrl + "test/error/" + data.type, request).then(response => {

				console.log('FP: response: ', response);

				return util.getJson(commit, response, data, rootState.debug).then(json => {

					/*if (json.status == "OK") {
						alert("OK");
					} else {
						alert("FAILED, " + json.message);
					}*/

					console.log('FP: json:', json);
					return json

				})


			}).catch(error => {
				console.error("FP: error: ", error);
				util.appendEventLogError(commit, "Error has occured. " + error, true)
				return { status: "FAIL", message: error }
			}).finally(() => {
				commit("requestComplete");

			})


		},
		/*testRemoteError({ commit }, { data }) {
			console.log("FP: ", commit);
			console.log("FP: ", data);


			return axios.get('test/error/' + data.type
			).then(result => {
				alert("OK");
				util.handleResult(result, commit);

				return result

			})


		},*/

		getBaseModel({ commit, rootState }, { data }) {

			console.log("FP: ", data);


			if (this.state.baseModelLoading) {
				console.log('FP: baseModel laddas redan');
				return null;

			}

			commit("requestStart");
			commit(SET_BASE_MODEL_LOADING, true)

			const request = util.getGETRequest(this.state.loginToken, data.background);

			return fetch(settings.baseUrl + "model/base", request).then(response => {

				console.log('FP: response: ', response);

				return util.getJson(commit, response, data, rootState.debug).then(json => {

					if (json.status == "OK") {

						util.appendEventLog(commit, "Reguest base-model complete, OK")

						commit("updateBaseModel", json.baseModel)

						

						

						if (json.apiVersion > 0) {

							if (this.state.apiVersion == 0){ // första körningen

								commit("updateApiVersion", json.apiVersion)

							}else if (this.state.apiVersion > 0 && this.state.apiVersion < json.apiVersion) { // om appversion har blivit högre. 

								util.appendEventLogError(commit, "Det finns en ny version av sidan att hämta.\nDu behöver starta om din webbläsare eller ladda om sidan.")
								//alert("Det finns en ny version av sidan att hämta.\nDu behöver starta om din webbläsare eller ladda om sidan.")
							}

							//commit("updateApiVersion", json.apiVersion)
						}
						return json
					}
				})
			}).catch(error => {
				console.error("FP: error getBaseModel: ", error);
				util.appendEventLogError(commit, "Error has occured. (getBaseModel) " + error, true)
				return { status: "FAIL", message: error }
			}).finally(() => {
				commit("requestComplete");
				commit(SET_BASE_MODEL_LOADING, false)

			})
		},

		/*getBaseModel({ commit }, { data }) {

			console.log("FP: ", data);

			commit("requestStart");

			const headers = util.getHeaders(this.state.loginToken, data.background);

			return axios.get('model/base', { headers: headers }
			).then(result => {

				util.handleResult(result, commit);

				if (result && result.data && result.data.status == "OK") {
					util.appendEventLog(commit, "Reguest base-model complete, OK")
					//commit("updateBaseModel", result.data.baseModel)
					commit("updateBaseModel", result.data)

					if (result.data.apiVersion > 0) {

						if (this.state.apiVersion > 0 && this.state.apiVersion < result.data.apiVersion) {
							alert("Du behöver starta om din webbläsare.")

						}

						commit("updateApiVersion", result.data.apiVersion)

					}

					return result
				}



			}).catch(error => {
				util.handleError(error, commit);
			}).finally(() => {
				commit("requestComplete");
			})
		},*/
		getStartModel({ commit, rootState }, { data }) {

			console.log("FP: ", data);

			commit("requestStart");

			const request = util.getGETRequest(this.state.loginToken, data.background);

			return fetch(settings.baseUrl + "model/start", request).then(response => {

				console.log('FP: response: ', response);

				return util.getJson(commit, response, data, rootState.debug).then(json => {

					if (json.status == "OK") {

						util.appendEventLog(commit, "Reguest getStartModel complete, OK")

						commit("updateStartModel", json.startModel)


						return json
					}
				})
			}).catch(error => {
				console.error("FP: error getStartModel: ", error);
				util.appendEventLogError(commit, "Error has occured. (getStartModel) " + error, true)
				return { status: "FAIL", message: error }
			}).finally(() => {
				commit("requestComplete");

			})
		},
		getSearchIndexModel({ commit, rootState }, { data }) {

			console.log("FP: ", data);

			if (this.state.searchIndexModelLoading) {
				console.log('FP: getSearchIndexModel laddas redan');
				return null;

			}

			commit("requestStart");
			commit(SET_SEARCH_INDEX_MODEL_LOADING, true)

			const request = util.getGETRequest(this.state.loginToken, data.background);

			return fetch(settings.baseUrl + "model/search-index", request).then(response => {

				console.log('FP: response: ', response);

				return util.getJson(commit, response, data, rootState.debug).then(json => {

					if (json.status == "OK") {

						util.appendEventLog(commit, "Reguest getSearchIndexModel complete, OK")

						commit("updateSearchIndexModel", json.searchIndexModel)


						return json
					}
				})
			}).catch(error => {
				console.error("FP: error getgetSearchIndexModelStartModel: ", error);
				util.appendEventLogError(commit, "Error has occured. (getSearchIndexModel) " + error, true)
				return { status: "FAIL", message: error }
			}).finally(() => {
				commit(SET_SEARCH_INDEX_MODEL_LOADING, false)
				commit("requestComplete");

			})
		},
		/*getStartModel({ commit }, { data }) {

			console.log("FP: ", data);
			commit("requestStart");

			return axios.get('model/start'
			).then(result => {

				util.handleResult(result, commit);
				if (result && result.data && result.data.status == "OK") {
					util.appendEventLog(commit, "Reguest start-model complete, OK")
					//commit("updateStartModel", result.data.startModel)
					commit("updateStartModel", result.data)
					return result
				}

			}).catch(error => {
				util.handleError(error, commit);
			}).finally(() => {
				commit("requestComplete");
			})


		},*/
		login({ commit, rootState }, { data }) {
			console.log("FP: ", commit);
			//console.log("FP: ", data);

			commit("requestStart");

			const request = util.getPOSTRequest(this.state.loginToken, data.background, { username: data.username, password: data.password });

			return fetch(settings.baseUrl + "auth/login", request).then(response => {

				console.log('FP: response: ', response);

				return util.getJson(commit, response, data, rootState.debug).then(json => {

					if (json.status == "OK") {

						util.appendEventLog(commit, "Login, OK")
						commit(STORE_COMMIT.SET_LOGIN_TOKEN, json.loginToken);
						commit(USER_STORE_COMMIT.UPDATE_USER_MODEL, json.userModel);

						if (json.userModel?.productGroupList){
							commit(PRODUCT_STORE_COMMIT.UPDATE_PRODUCT_GROUP_LIST, json.userModel.productGroupList);
						}
						

						return json
					}
				})
			}).catch(error => {
				console.error("FP: error login: ", error);
				util.appendEventLogError(commit, "Error has occured. (login) " + error, true)
				return { status: "FAIL", message: error }
			}).finally(() => {
				commit("requestComplete");

			})

		},
		/*login({ commit }, { data }) {
			console.log("FP: ", commit);
			console.log("FP: ", data);

			commit("requestStart");

			return axios.post('auth/login', { username: data.username, password: data.password }
			).then(result => {

				util.handleResult(result, commit);

				if (result && result.data && result.data.status == "OK") {
					util.appendEventLog(commit, "Login, OK")
					commit("setLoginToken", result.data.loginToken);
					return result
				}



			}).catch(error => {
				util.handleError(error, commit);
			}).finally(() => {
				commit("requestComplete");
			})

		},*/
		logout({ commit, rootState }, { data }) {

			
			console.log("FP: ", commit);
			console.log("FP: ", data);

			commit("requestStart");

			const request = util.getGETRequest(this.state.loginToken, data.background);

			return fetch(settings.baseUrl + "auth/logout", request).then(response => {

				console.log('FP: response: ', response);

				return util.getJson(commit, response, data, rootState.debug).then(json => {


					if (json.status == "OK") {
						alert("Logout OK");
						util.appendEventLog(commit, "Logout, OK")
						return json
					}
				})
			}).catch(error => {
				console.error("FP: error logout: ", error);
				util.appendEventLogError(commit, "Error has occured. (logout) " + error, true)
				return { status: "FAIL", message: error }
			}).finally(() => {
				commit(STORE_COMMIT.SET_LOGIN_TOKEN, null);
				commit(USER_STORE_COMMIT.DELETE_USER_MODEL);
				commit("requestComplete");

			})

		},
		/*logout({ commit }, { data }) {
			console.log("FP: ", commit);
			console.log("FP: ", data);

			commit("requestStart");

			return axios.get('auth/logout'
			).then(result => {

				util.handleResult(result, commit);

				if (result && result.data && result.data.status == "OK") {
					util.appendEventLog(commit, "Logout, OK")
					return result
				}



			}).catch(error => {
				util.handleError(error, commit);
			}).finally(() => {
				commit("requestComplete");
			})

		},*/
		getStatus({ commit, rootState }, { data }) {

			console.log("FP: ", data);

			commit("requestStart");

			const request = util.getGETRequest(this.state.loginToken, data.background);

			return fetch(settings.baseUrl + "auth/status", request).then(response => {

				console.log('FP: response: ', response);

				const silent = true;

				return util.getJson(commit, response, data, rootState.debug, silent).then(json => {


					if (json.status == "OK") {

						util.appendEventLog(commit, "Reguest status complete, OK")

						console.log('FP: Json: ', json);



						if (json.apiVersion > 0) {

							if (this.state.apiVersion > 0 && this.state.apiVersion < json.apiVersion) {
								alert("Du behöver ladda om sidan")
							}

							commit("updateApiVersion", json.apiVersion)
						}
						return json
					}

				})
			}).catch(error => {
				console.error("FP: error status: ", error);
				

				if (error && error.message && error.message.includes("401")) {

					// FP: 2026 här kan man fånga upp om man blivit utloggad. 

					if (!this.state.loginToken){
						util.appendEventLog(commit, "Du har blivit utloggad"); 
					}

					
					commit(STORE_COMMIT.SET_LOGIN_TOKEN, null);
					commit(USER_STORE_COMMIT.DELETE_USER_MODEL);

					return { status: "FAIL", message: "Du måste logga in", header: 401 }

				} else {
					
					util.appendEventLogError(commit, "Ett fel har inträffat" + error, true)
					return { status: "FAIL", message: error }
				}

			}).finally(() => {
				commit("requestComplete");

			})
		},

		/*getStatus({ commit }, { data }) {

			console.log("FP: ", data);

			commit("requestStart");

			const headers = util.getHeaders(this.state.loginToken, data.background);

			return axios.get('auth/status', { headers: headers }
			).then(result => {

				util.handleResult(result, commit);

				if (result && result.data && result.data.status == "OK") {


					if (result.data.apiVersion > 0) {

						if (this.state.apiVersion > 0 && this.state.apiVersion < result.data.apiVersion) {
							alert("Du behöver starta om din webbläsare.")

						}

						commit("updateApiVersion", result.data.apiVersion)

					}

					return result
				}



			}).catch(error => {
				util.handleError(error, commit);
			}).finally(() => {
				commit("requestComplete");
			})
		},*/

		append({ commit, rootState }, { data }) {

			console.log("FP: ", data);

			commit("requestStart");

			const request = util.getGETRequest(this.state.loginToken, data.background);

			return fetch(settings.baseUrl + "auth/append", request).then(response => {


				return util.getJson(commit, response, data, rootState.debug).then(json => {


					if (json.status == "OK") {

						util.appendEventLog(commit, "Reguest append complete, OK")

						console.log('FP: Json: ', json);

						alert("Appended");

						return json
					}

				})
			}).catch(error => {
				console.error("FP: error append: ", error);
				util.appendEventLogError(commit, "Error has occured. (append) " + error, true)

			}).finally(() => {
				commit("requestComplete");

			})
		},
		searchProductA({ commit, getters }, { data }) { // FP: utför själva sökningen. 

			console.log("FP: ", commit);
			console.log("FP: ", data);



			// hämtar listan med produkter från search-modellen
			const productList = getters.searchModel.productList;

			var searchPhrase = getters.searchProductConfig.searchPhrase;

			console.log('FP: search: START  searchPhrase: ', searchPhrase);

			return searchUtil.searchProductA(searchPhrase, productList).then(searchProductResult => {

				
				commit("setSearchProductResult", searchProductResult)

				console.log('FP: search: DONE:', searchPhrase);

				return { currentSearchPhrase: searchPhrase }

			})



			/*
			await searchUtil.searchProductA(null, "prod", data.productList).then(searchProductResult => {
				commit("setSearchProductResult", searchProductResult)
				console.log('FP: Start search DONE');

			})*/


		},
		async rebuildSearchModelAction({ commit, state }) {
			commit(STORE_COMMIT.SET_REBUILD_SEARCH_MODEL, true);
			const model = await searchUtil.rebuildSearchModel(state)
			commit(STORE_COMMIT.SET_SEARCH_MODEL, model, { root: true });
			commit(STORE_COMMIT.SET_REBUILD_SEARCH_MODEL, false);
			return model;
		}
	},
	mutations: {


		setSortSearch(state) {
			state.searchProductConfig.sort = STORE_SORT.SORT_SEARCH

		},

		setSort(state, sort) {
			state.searchProductConfig.sort = sort
		},

		setSearchProductResult(state, searchProductResult) {


			

			// här ska vi loopa igenom produkterna och uppdatera listor med id till kategori och mc 
			searchProductResult.categoryIdMap = new Map();
			searchProductResult.mcIdMap = new Map();


			const categoryPathIdList = state.searchIndexModel?.categoryPathIdListForProductId

			const mcPathIdList = state.searchIndexModel?.mcPathIdListForProductId
			
			searchProductResult.productList.forEach(entity => {

				//console.log('FP: setSearchProductResult entityId: ', entity.entityId);

				// hämta listan av id till kategorier
				const categoryIdList = categoryPathIdList?.[entity.entityId] ?? []

				categoryIdList.forEach(categoryId => {
					searchProductResult.categoryIdMap.set(categoryId, true)
				})

				// hämta listan av id till mc-modeller
				const mcIdList = mcPathIdList?.[entity.entityId] ?? []

				mcIdList.forEach(mcId => {
					searchProductResult.mcIdMap.set(mcId, true)
				})
				
			})

			console.log('FP: setSearchProductResult', searchProductResult);

			state.searchProductResult = searchProductResult

		},



		/* CO2 rebuildSearchModel(state) { // FP: Bygger om sökmodellen, ska anropas när något sökkretieri har ändrats. Skapar grundmodellen att söka i. 

			//searchModel
			console.log('FP: search rebuildSearchModel()');

			state.searchModel = searchUtil.rebuildSearchModel(state)

			//console.log('FP: rebuildSearchModel() complete: ', state.searchModel);

		},*/

		// CO2
		setSearchModel(state, model){
			state.searchModel = model
		},

		searchProduct(state) {

			state.searchProductResult = searchUtil.searchProduct(state)
		},

		setSearchProductConfig(state, searchProductConfig) {
			state.searchProductConfig = searchProductConfig
		},


		setLoginToken(state, loginToken) {
			state.loginToken = loginToken
		},
		setAllEventsRead(state) {
			state.eventList.map(event => {
				event.read = true
			})
		},

		setPageMenuOpen(state, pageMenuOpen) {
			state.pageMenuOpen = pageMenuOpen
		},

		setSideMenuKey(state, sideMenuKey) {
			state.sideMenuKey = sideMenuKey
		},

		selectProductType(state, productType){
			state.productTypeModel.selected = productType
		},

		selectProductTypeByUrlKey(state, productTypeUrlKey){

			const productType = state.productTypeModel?.list.find(productType => productType.urlKey == productTypeUrlKey);

			if (productType){
				//alert("found: " + productType.key)
				state.productTypeModel.selected = productType
			}

		},

		selectProductTypeByPT(state, pt){

			const productType = state.productTypeModel?.list.find(productType => productType.pt == pt);
			if (productType){
				state.productTypeModel.selected = productType
			}

		},

		selectProductGroupKey(state, productGroupKey){
			state.searchProductConfig.productGroupKey = productGroupKey
		},

		createModel(state) { // (ej: Gör själva sökningen i produktlistan) hämtar snarare fram sökresultatet.  

			console.log('FP: search: createModel start');


			var model = { totalCount: 0, resultCount: 0, productList: [], productListSearch: [] };

			//model.type = "config"
			if (state.searchProductConfig.productList) {
				model.totalCount = this.searchProductConfig.productList.length
			} else {
				model.totalCount = 0;
			}

			console.log('FP: search: createModel model.totalCount: ', model.totalCount);

			var productList = [];

			//alert(state.searchProductResult.productList?.length)
			const addedProductIds = new Set(); // FP: 2026 bugg fix för att ta bort ev dubletter ur listan
			
			// hämta ut träffar, bygg 
			state.searchProductResult.productList.filter(entity => entity !== null).forEach(entity => {

				// redan tillagd
				if (addedProductIds.has(entity.entityId)) {
					console.log("FP: search: dublett i listan");
					return;
				}

				const product = state.productStore.data.productList[entity.entityId];

				if (product){

					addedProductIds.add(entity.entityId);

					if (entity.search && entity.search.totalScore > 0) {
						product.score = entity.search.totalScore
					} else {
						product.score = 0;
					}

					product.entity = entity
					productList.push(product)
				
				}
				
			})


			// exkludera från resultatet, finns även i productSearchMixin
			productList = productList.filter(product => !searchUtil.excludeProductFromResult(product, this.state.searchProductConfig))
			

			// FP: 2026: model.productListSearch = productList.filter(product => product != null).sort((a, b) => b.score - a.score).slice(0, 2);
			
			// här görs sorteringen till default-söklistan till <SearchPopoverView>
			model.productListSearch = productList.filter(product => product != null).sort((a, b) => {

				const scoreDiff = b.score - a.score;

				if (scoreDiff !== 0) {
					return scoreDiff;
				}

				return b.productId - a.productId;
			})?.slice(0, 12);
			

			
			//model.productListSearch = productList.filter(product => product != null).sort((a, b) => b.productId - a.productId).slice(0, 12);

			// sortera på bäst score, lägg till flera sorts

			//productList = productList.sort((a, b) => b.score - a.score)

			model.totalCount = productList.length


			model.resultCount = productList.length;

			// sortera på kolumner
			//productList = listHelper.sortList(productList, this.tableConfig.sort, this.tableConfig.desc);
			//if (this.searchProductConfig && this.searchProductConfig.sort) {
			//	productList = listHelper.sortList(productList, this.searchProductConfig.sort.property, this.searchProductConfig.sort.desc);
			//}


			//model.resultCount = productList.length;

			// trimma till rätt längd
			//productList = listHelper.trimToLimit(productList, this.tableConfig.scrollLimit);

			model.productList = productList;

			console.log('FP: search createModel: DONE', model);

			//this.model2 = model;

			state.searchProductConfig.model2 = model; // här lägger vi in modellen som modell 2 på objektet i store. 



			//return model;



		},

		updateBaseModel(state, baseModel) {
			state.baseModel = baseModel

			if (state.baseModel && state.baseModel.mcTree){

				state.baseModel.mcTree.map(brand => {

					brand.modelList.map(mc => {
						mc.brandId = brand.id;
						mc.brandName = brand.name;
						mc.search = brand.name + " " + mc.modelName + " " + mc.modelName.replaceAll(" ", "");
					})


				})
			}

			// uppdatera ProductGroupList
			if (baseModel?.productGroupList){

				baseModel.productGroupList?.forEach(productGroup => {
					const key = productGroup.key;

					// radera om key redan finns 
					state.productStore.data.productGroupList = state.productStore.data.productGroupList?.filter(productGroup => productGroup.key != key)

					// addera
					state.productStore.data.productGroupList.push(productGroup);

				})
				
			}

			state.baseModelCompleteDate = Date.now();
			console.log('FP: updateBaseModel: mcList: ', state.baseModel);

		},

		updateStartModel(state, startModel) {
			state.startModel = startModel
		},

		updateSearchIndexModel(state, searchIndexModel){
			state.searchIndexModel = searchIndexModel
		},

		appendEventLog(state, event) {


			let id = 0;

			state.eventList.forEach(event => {
				if (event.id > id) {
					id = event.id;
				}
			})



			/*
						if (event.status == "ERROR" && state.eventList.find(event =>
							event.status == "ERROR" && 
						) == null) {
							alert("Ett fel har inträffat.\n" + event.message);
						}
			*/

			event.id = (id + 1)
			event.date = new Date().toLocaleTimeString()
			event.read = false
			event.new = true
			state.eventList.unshift(event); // message, type, read. 




			state.eventList = state.eventList.slice(0, 50);

		},

		displayedEvent(state, eventId) {

			state.eventList.map(event => {
				if (event.id == eventId) {
					event.new = false
				}
			})
		},

		updateTableConfig(state, tableConfig) {


			const key = tableConfig.key;

			state.tableConfigs = state.tableConfigs.filter(tableConfig => tableConfig.key != key);

			console.log('FP: state.tableConfigs length före: ', state.tableConfigs.length);
			state.tableConfigs.push(tableConfig);
			console.log('FP: state.tableConfigs length efter: ', state.tableConfigs.length);

			console.log('FP: state.tableConfigs: ', state.tableConfigs);

		},
		updateApiVersion(state, apiVersion) {
			state.apiVersion = parseInt(apiVersion);
		},
		toggleDebug(state) {
			state.debug = !state.debug
		},

		userIsActive(state) {
			state.userActive = new Date();
		},

		requestStart(state) {
			state.requestCount++
		},

		setBaseModelLoading(state, baseModelLoading){
			state.baseModelLoading = baseModelLoading
		},

		setSearchIndexModelLoading(state, searchIndexModelLoading){
			state.searchIndexModelLoading = searchIndexModelLoading;
		},

		setShowStartSpinner(state, show){
			state.showStartSpinner = show
		},

		setRebuildingSearchModel(state, rebuildingSearchModel){
			state.rebuildingSearchModel = rebuildingSearchModel
		},

		requestComplete(state) {

			state.requestCount--

			if (state.requestCount < 0) {
				state.requestCount = 0;
			}
		}

	},

	modules: {
		productStore,
		userStore,

	}
})


